import environment from '../../../../common/environment';
import {
  CreateSearchRequest,
  CreateSearchResultDocument,
  PerformCreateSearchParams,
} from '../interfaces/create-search.interface';
import { getImageSrcUrl } from '../../../../common/utils/product-util';
import { processSearchTerms } from '../../../../common/utils/search-util';

export function getCreateSearchUrl(): string {
  return `${environment().searchServiceUrl}/customproduct/search`;
}

export function getCreateImage(document: CreateSearchResultDocument): string {
  if (document?.coverImage) {
    return environment().mheducationUrl + '/create-images/' + document.coverImage + '.jpg';
  } else {
    return getImageSrcUrl(document.isbn10 || document.isbn13);
  }
}

/**
 * Builds and returns the Create search body based on the parameters.
 *
 * @param params
 */
export function getCreateSearchBody(params: PerformCreateSearchParams): CreateSearchRequest {
  const body: CreateSearchRequest = {
    hits: true,
    facets: params.facets || true,
    searchValue: processSearchTerms(params.searchValue),
    start: params.start || 0,
    pageSize: params.pageSize || 10,
    excludeFacetName: params.excludeFacetName,
  };

  if (params.fieldValueFilter && Object.keys(params.fieldValueFilter).length > 0) {
    body.fieldValueFilter = params.fieldValueFilter;
  }

  return body;
}
